module.exports = "/assets/b2052082c9ece3274e2a11f15601ea8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MI.png
// module id = 1615
// module chunks = 0